module.exports = __webpack_public_path__ + "img/pic_17.dafcbcb6.jpg";